export const MenuItems = [
    {
      title : "Home",
      url : "/",
      cName : "nav-links",
      icon : "fa-solid fa-house-chimney"   
    },

    {
      title : "Services",
      url : "/service",
      cName : "nav-links",
      icon : "fa-solid fa-info"   
    },

    {
      title : "Contact",
      url : "/contact",
      cName : "nav-links",
      icon : "fa-solid fa-address-book"   
    },

    {
        title : "About",
        url : "/about",
        cName : "nav-links",
        icon : "fa-solid fa-circle-info"   
      },

      

      {
        title : "Blog",
        url : "/blog",
        cName : "nav-links",
        icon : "fa-solid fa-blog"   
      },

     
]